'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateNodeInDevMode;

var _felaUtils = require('fela-utils');

var _renderToSheetList = require('../../server/renderToSheetList');

var _renderToSheetList2 = _interopRequireDefault(_renderToSheetList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // This method is quite hacky and in-performant, but yet
// the most simple way to respect rule sorting even in devMode


function updateNodeInDevMode(renderer, node) {
  var sheetList = (0, _renderToSheetList2.default)(renderer);
  var media = node.getAttribute('media') || undefined;
  var support = node.getAttribute('data-fela-support') || undefined;
  var currentSheet = sheetList.find(function (sheet) {
    return sheet.type === _felaUtils.RULE_TYPE && sheet.media === media && sheet.support === support;
  });

  if (currentSheet) {
    node.textContent = currentSheet.css;
  }
}